export const formatCurrency = (
  value: number,
  currencyCode: string,
  locale: string = 'en',
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode || 'EUR',
  }).format(value)
}

export const capitalize = (str: string | undefined): string => {
  if (typeof str === 'undefined') return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}
